<template>
	<VInput
		ref="company-pan-input"
		v-model="company.additionalAttributes.pan.value"
		:label="company.additionalAttributes.pan.name"
		layout="vertical"
		:validate-method="InUtils.validatePAN"
		:disabled="readOnly"
	/>
</template>

<script>

import InUtils from "@/core/utils/regional/InUtils";
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'INAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			InUtils,
		}
	},
};
</script>

